import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-worksheet-page',
  templateUrl: './worksheet-page.component.html',
  styleUrls: ['./worksheet-page.component.scss']
})
export class WorksheetPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
